import gql from 'graphql-tag';

export const countries = gql`
  query countries($limit: Int = 999) {
    countries(slice: { limit: $limit }) {
      records {
        id
        name
      }
    }
  }
`;
